<div class="content-div">
  <app-biq-progress-bar 
    [questNo]="questNo"
    [totalQuestions]="totalQuestions"
  ></app-biq-progress-bar>

  <div class="form-div">
    <form class="user-form">
      <p class="heading">What is your name?</p>
      <div class="name-div">
        <div class="field-group">
          <label class="field-label" for="firstname">First name</label>
          <mat-form-field class="full-width rounded-input black-caret"
            [class.valid-input]="firstnameControl.valid && firstnameControl.value"
            [class.invalid-input]="firstnameControl.invalid && firstnameControl.touched"
          >
            <input 
              id="firstname"
              type="text" 
              matInput 
              [formControl]="firstnameControl" 
            >
            @if (firstnameControl.hasError('required') || firstnameControl.hasError('pattern')) {
              <mat-error class="input-error">First name is required</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field-group">
          <label class="field-label" for="lastname">Last name</label>
          <mat-form-field class="full-width rounded-input black-caret"
            [class.valid-input]="lastnameControl.valid && lastnameControl.value"
            [class.invalid-input]="lastnameControl.invalid && lastnameControl.touched"
          >
            <input 
              id="lastname"
              type="text" 
              matInput 
              [formControl]="lastnameControl" 
              
            >
            @if (lastnameControl.hasError('required') || lastnameControl.hasError('pattern')) {
              <mat-error class="input-error">Last name is required</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <app-biq-button (buttonEmitter)="onClickContinue()"></app-biq-button>
    </form>
  </div>
</div>
      